import { getResponsiveImage } from '../getResponsiveImage';

export const getImageSrcset = (image: string, $format?: string) => {
    const mobile = `${getResponsiveImage(image, 'mobile', $format)} 768w`;
    const tablet = `${getResponsiveImage(image, 'tablet', $format)} 992w`;
    const desktop = `${getResponsiveImage(image, 'desktop', $format)} 1440w`;
    const desktopBig = `${getResponsiveImage(
        image,
        'big-desktop',
        $format,
    )} 1920w`;

    return `${mobile}, ${tablet}, ${desktop}, ${desktopBig}`;
};
